var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Loader = function (props) { return (_jsx("div", __assign({ className: "loader".concat(props.isButton ? ' button' : '') }, { children: _jsx("i", { className: "fas fa-spinner" }) }))); };
export default Loader;
